import angular from 'angular';
import loginComponent from './login.component';
import LoginService from './login.service';
import ModalLoginResponseController from './modal-login-response/modal-login-response.controller';
import ModalSelectBranchController from './modal-select-branch-b2b-user/modal-select-branch-b2b-user.controller';
import loginConfig from './login.config';

let loginModule = angular.module('app.login',[])
  .component('login', loginComponent)
  .controller('ModalSelectBranchController', ModalSelectBranchController)
  .controller('ModalLoginResponseController', ModalLoginResponseController)
  .service('LoginService', LoginService)
  .config(loginConfig);

export default loginModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/login/login.js
 **/